var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCutting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E1E3E3;}\n\t.st4{fill:#FFD1D1;}\n\t.st5{fill:none;}\n\t.st6{fill:#0A1514;}\n\t.st7{fill:#C0C3C3;}\n\t.st8{fill:#821bb8;}\n\t.st9{fill:#677371;}\n\t.st10{fill:none;stroke:#677371;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#F8D1CF;}\n\t.st12{fill:#EE8B88;}\n\t.st13{display:inline;fill:#C0C3C3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -495,
    y: -1757,
    className: "st2",
    width: 800,
    height: 3706
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "main"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.5,26.2c-0.8-1.5-2.8-2.1-4.3-1.3c0.5,0.3,1,0.7,1.3,1.3c0.8,1.5,0.3,3.5-1.2,4.3c0,0,0,0,0,0 c0.9,0.5,2.1,0.5,3,0C26.8,29.7,27.4,27.7,26.5,26.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.5,26.2c-0.8-1.5-2.8-2.1-4.3-1.3c0.5,0.3,1,0.7,1.3,1.3c0.8,1.5,0.3,3.5-1.2,4.3c0,0,0,0,0,0 c0.9,0.5,2.1,0.5,3,0C11.8,29.7,12.4,27.7,11.5,26.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.7,24.1c-0.7,0.4-1.2,1-1.6,1.6l-1.9-3.4c1.7-0.6,3.1-1.9,3.7-3.7l5.9-17.1c0.2-0.5-0.1-1-0.5-1.2 c-0.5-0.2-1,0-1.3,0.4l-9.9,17.9L6.3,0.6C6,0.2,5.5,0,5,0.2C4.5,0.4,4.3,0.9,4.5,1.4l5.9,17.1c0.6,1.8,2,3.1,3.7,3.7l-1.9,3.4 c-0.4-0.7-0.9-1.2-1.6-1.6c-1-0.5-2.1-0.7-3.2-0.4c-1.1,0.3-2,1-2.5,2c-1.1,2-0.4,4.6,1.6,5.7c0.6,0.4,1.3,0.5,2,0.5 c1.5,0,2.9-0.8,3.7-2.2c0-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.1-0.2l3.7-6.7l0,0l0,0l3.7,6.7c0,0.1,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.2,0.1,0.2c0.5,1,1.4,1.7,2.5,2c0.4,0.1,0.8,0.2,1.2,0.2c0.7,0,1.4-0.2,2-0.5c2-1.1,2.7-3.7,1.6-5.7 C26.3,23.7,23.7,23,21.7,24.1z M22.2,11.7l-2.1,6.1c-0.4,1.3-1.4,2.2-2.7,2.5L22.2,11.7z M12.3,17.9l-2.1-6.1l4.8,8.7 C13.7,20.1,12.7,19.1,12.3,17.9z M9.2,29.8C8.6,30,8,29.9,7.5,29.6c-1-0.6-1.4-1.9-0.9-3c0.3-0.5,0.7-0.9,1.3-1 c0.6-0.2,1.1-0.1,1.7,0.2c0.5,0.3,0.9,0.7,1,1.3c0.2,0.6,0.1,1.1-0.2,1.7C10.2,29.3,9.7,29.7,9.2,29.8z M24.8,29.6 c-0.5,0.3-1.1,0.3-1.7,0.2c-0.6-0.2-1-0.5-1.3-1c-0.6-1-0.2-2.4,0.9-3c0.3-0.2,0.7-0.3,1-0.3c0.8,0,1.5,0.4,1.9,1.1 C26.2,27.7,25.8,29.1,24.8,29.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cm",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    width: 32,
    height: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutting);
export default __webpack_public_path__ + "static/media/cutting.7ebaea784707fd5ba58c474ab4cb5554.svg";
export { ForwardRef as ReactComponent };